import { render, staticRenderFns } from "./overseas.vue?vue&type=template&id=772bff02&scoped=true&"
import script from "./overseas.vue?vue&type=script&lang=js&"
export * from "./overseas.vue?vue&type=script&lang=js&"
import style0 from "./overseas.vue?vue&type=style&index=0&id=772bff02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772bff02",
  null
  
)

export default component.exports